import Backbone from 'backbone';
import _ from 'underscore';

import { requestBegins, requestEnds } from '../loader';



export { postpone, delay, resolveOn, rejectOn, requestify, promisify, deferred };



const listener = _.extend( {}, Backbone.Events );

function postpone() {
    return delay( 0 );
}

function delay(ms) {
    return new Promise( resolve => 
        setTimeout( resolve, ms ) );
}

function rejectOn(event, context) {
    return new Promise( (resolve, reject) =>
        listener.listenToOnce( context, event, reject ) );
}

function resolveOn(event, context) {
    return new Promise( resolve =>
        listener.listenToOnce( context, event, resolve ) );
}

function requestify(deferred) {
    requestBegins();

    const request = promisify( deferred );
    return request.then( requestEnds, requestEnds ),
        request;
}

function promisify(deferred) {
    if ('boolean' === typeof deferred)
        return Promise.resolve( deferred ); 

    if ('number' === typeof deferred)
        return Promise.resolve( deferred ); 

    if ('boolean' === typeof deferred)
        return Promise.resolve( deferred ); 

    if (undefined === deferred)
        return Promise.resolve( deferred ); 

    if (null === deferred)
        return Promise.resolve( deferred ); 

    if (deferred instanceof Promise)
        return deferred;
        
    if (!deferred.always)
        return Promise.resolve( deferred );
        
    return new Promise( (resolve, reject) => deferred.then( resolve, reject ) );
}

function deferred(promise) {
    return Backbone.$.Deferred( def =>
        promise.then( (...args) => def.resolve( ...args ), 
            (...args) => def.reject( ...args ) ) ).promise();
}


// WEBPACK FOOTER //
// ./src/js/utils/promisify.js